import { map } from "rxjs/operators";
import { GET, POST } from "../../../module/services/fetch";

export const fetchExample = () =>
  GET("document/last").pipe(map((response: any) => response));

export const fetchHistoryRequest = (payload: any) => {
  const { body, sortBy } = payload;
  return POST(
    `request/find${
      sortBy && sortBy.length > 0
        ? `?sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? "desc" : "asc"
          }`
        : `?sortField=created_on&sortOrder=desc`
    }`,
    body
  ).pipe(map((response: any) => response));
};

export const retryRequestService = (payload: string[]) => {
  return POST(`request/retry/requests`, payload).pipe(
    map((response: any) => response)
  );
};

export const fetchCsvHistoryRequest = (payload: any) => {
  const { body, sortBy } = payload;
  return POST(
    `request/find-all${
      sortBy && sortBy.length > 0
        ? `?sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? "desc" : "asc"
          }`
        : `?sortField=created_on&sortOrder=desc`
    }`,
    body
  ).pipe(map((response: any) => response));
};

export const fetchHistoryDetail = (id: string) =>
  GET(`request/${id}/details`).pipe(map((response: any) => response));
